import { render } from "./BindAccounts.vue?vue&type=template&id=7bcd6973&scoped=true"
import script from "./BindAccounts.vue?vue&type=script&lang=js"
export * from "./BindAccounts.vue?vue&type=script&lang=js"

import "./BindAccounts.vue?vue&type=style&index=0&id=7bcd6973&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bcd6973"]])

export default __exports__